module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"sitesTitle":"Lokasyonlar","tableSiteName":"Lokasyon Adı","tableDataHealth":"Veri Sağlığı","sitesWithoutAgents":"Sürdürülebilirlik Temsilcisi Olmayanlar"},"en":{"sitesTitle":"Sites","tableSiteName":"Site","tableDataHealth":"Data Health","sitesWithoutAgents":"Sites without agents"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Setting/Site.vue
// module id = PcT9
// module chunks = 1